import { SearchFields } from './product.model';

export class DownloadRequest {
  ngsMerchantId?: string;
  searchFields?: SearchFields[];
  reportType?: string;
  from?: string;
  to?: string;
}
